import type { TSelectOption } from "@/components/forms/Select/Select";

export type TDynamicFieldMetadata = {
  key: string;
  label: string;
  data_type: string;
  active: boolean;
  sort_order: number;
  placeholder: string | null;
  options?: TEmployeeAttributeOption[];
};

type TEmployeeAttributeOption = {
  key?: string | number;
  label?: string | number;
  value?: string | number;
};

export const getEmployeeAttributeOptions = (
  options?: TEmployeeAttributeOption[],
): TSelectOption[] => {
  if (!Array.isArray(options)) return [];

  return options.map((option) => {
    const value = String(option.value ?? option.key ?? "");
    return {
      value,
      label: String(option.label ?? option.value ?? value),
    };
  });
};

export const getEmployeeAttributeChipValue = (
  fields: TDynamicFieldMetadata[],
  key: string,
  value: string,
) => {
  const field = fields.find((item) => item.key === key);
  const selectedOption = getEmployeeAttributeOptions(field?.options).find(
    (option) => option.value === value,
  );

  return {
    label: field?.label ?? key,
    value: selectedOption?.label ?? value,
  };
};
